const config = {
  "dev-extranet.hotelzify.com": {
    currency: "INR",
    country: "in",
    logo: "https://ik.imagekit.io/hotelzifyprod/logo.png",
    supportMobile: "+91 79756 60291",
    supportEmail: "support@hotelzify.com",
    dateFormat: "YYYY-MM-DD",
    hiddenFeatures: [
      "channelManager",
      "revenueManagement",
      "customWebsite",
      "walkinBooking",
    ],
  },
  "admin.hotelzify.com": {
    currency: "INR",
    country: "in",
    logo: "https://ik.imagekit.io/hotelzifyprod/logo.png",
    supportMobile: "+91 79756 60291",
    supportEmail: "support@hotelzify.com",
    dateFormat: "YYYY-MM-DD",
    hiddenFeatures: [
      "channelManager",
      "revenueManagement",
      "customWebsite",
      "walkinBooking",
    ],
  },
  "dev-lodgequix.hotelzify.com": {
    currency: "USD",
    country: "us",
    logo: "https://hotelzify-prod-images-bucket.s3.ap-south-1.amazonaws.com/logo.svg",
    supportMobile: "+1 (803) 374-7193",
    supportEmail: "support@lodgequix.com",
    dateFormat: "MM-DD-YYYY",
    hiddenFeatures: ["customWebsite"],
  },
  "admin.lodgequix.com": {
    currency: "USD",
    country: "us",
    logo: "https://hotelzify-prod-images-bucket.s3.ap-south-1.amazonaws.com/logo.svg",
    supportMobile: "+1 (803) 374-7193",
    supportEmail: "support@lodgequix.com",
    dateFormat: "MM-DD-YYYY",
    hiddenFeatures: ["customWebsite"],
  },
  "localhost:3000": {
    currency: "INR",
    country: "in",
    logo: "https://ik.imagekit.io/hotelzifyprod/logo.png",
    supportMobile: "+91 79756 60291",
    supportEmail: "support@hotelzify.com",
    dateFormat: "YYYY-MM-DD",
    hiddenFeatures: ["channelManager", "revenueManagement", "customWebsite"],
  },
  "admin.lodgezify.com": {
    currency: "USD",
    country: "us",
    logo: "https://hotelzify-prod-images-bucket.s3.ap-south-1.amazonaws.com/lodgezify_logo.png",
    supportMobile: "+1 (800) 569-5305",
    supportEmail: "support@lodgezify.com",
    dateFormat: "MM-DD-YYYY",
    hiddenFeatures: ["customWebsite"],
  },
  // "localhost:3000": {
  //   currency: "USD",
  //   country: "us",
  //   logo: "https://hotelzify-prod-images-bucket.s3.ap-south-1.amazonaws.com/logo.svg",
  //   supportMobile: "+1 (803) 374-7193",
  //   supportEmail: "support@lodgequix.com",
  //   dateFormat: "MM-DD-YYYY",
  //   hiddenFeatures: ["customWebsite"],
  // },
};

export const getConfig = () => {
  const domain = window.location.host;
  // console.log("confi", config[domain]);
  return config[domain] ?? config["admin.hotelzify.com"];
};
